/* tslint:disable */

/**
 */
export class MeshGeneration {
    MESH_1_SIZE?: number;
    ID_MESH_GENERATION?: number;
    MESH_1_FIXED?: number;
    MESH_2_FIXED?: number;
    MESH_3_FIXED?: number;
    MESH_1_MODE?: number;
    MESH_2_MODE?: number;
    MESH_3_MODE?: number;
    MESH_1_NB?: number;
    MESH_2_NB?: number;
    MESH_3_NB?: number;
    ID_PROD?: number;
    MESH_2_SIZE?: number;
    MESH_3_SIZE?: number;
    MESH_1_INT?: number;
    MESH_2_INT?: number;
    MESH_3_INT?: number;
    MESH_1_RATIO?: number;
    MESH_2_RATIO?: number;
    MESH_3_RATIO?: number;
    BEST_1_NB?: number;
    BEST_2_NB?: number;
    BEST_3_NB?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/mesh-generation.ts